import React from 'react';
import { motion } from 'framer-motion';
export function Founder() {
  return <section className="py-32 bg-ivory text-midnight relative overflow-hidden" data-id="element-159">
      {/* Decorative background text */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full overflow-hidden pointer-events-none opacity-[0.03]" data-id="element-160">
        <h2 className="text-[20vw] font-display font-black whitespace-nowrap text-center leading-none" data-id="element-161">
          FOUNDER
        </h2>
      </div>

      <div className="max-w-5xl mx-auto px-6 relative z-10 text-center" data-id="element-162">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-col items-center" data-id="element-163">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-midnight text-gold rounded-full text-xs font-bold tracking-widest uppercase mb-12 rotate-[-2deg] shadow-lg" data-id="element-164">
            Founded 2019 • UNIBEN
          </div>

          <div className="relative max-w-4xl mx-auto" data-id="element-165">
            <span className="absolute -top-16 -left-10 text-8xl font-serif text-gold/30 select-none" data-id="element-166">
              "
            </span>
            <p className="text-3xl md:text-5xl lg:text-6xl font-serif italic leading-[1.3] text-midnight" data-id="element-167">
              Founded following profound spiritual encounters in 2017 and 2018.
              The ministry officially began its journey in January 2019 at the
              University of Benin with just three members. Today, it has grown
              into a global movement of intercessors.
            </p>
            <span className="absolute -bottom-16 -right-10 text-8xl font-serif text-gold/30 select-none rotate-180" data-id="element-168">
              "
            </span>
          </div>

          <div className="mt-16 flex flex-col items-center" data-id="element-169">
            <div className="w-16 h-1 bg-gold rounded-full mb-6" data-id="element-170" />
            <h3 className="text-2xl font-display font-bold tracking-tight" data-id="element-171">
              Ajayi, Osagioduwa Joseph
            </h3>
            <p className="text-sm font-bold tracking-widest uppercase text-charcoal/50 mt-2" data-id="element-172">
              Founder
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}